export default __webpack_public_path__ + "static/media/industrial_16.2fa016e6.png";